<template>
	<a
		:href="item.url"
		class="c-insights-tile">
		<figure class="c-insights-tile__figure">
			<picture v-if="item.image && item.image.cropUrl">
				<source
					:srcset="item.image.cropUrl + '?format=webp'"
					type="image/webp" />
				<img
					class="c-insights-tile__image"
					:src="item.image.cropUrl"
					loading="lazy"
					:alt="item.image.altText" />
			</picture>

			<img
				v-else
				class="c-insights-tile__image c-insights-tile__image--placeholder"
				src="/Content/images/interface/logo/buddlefindlay-logo.svg"
				:alt="item.title" />
		</figure>

		<div class="c-insights-tile__categories">
			<span
				v-if="item.type && item.type.name"
				class="c-insights-tile__category"
				>{{ item.type.name }}</span
			>
		</div>

		<h4
			class="c-insights-tile__title"
			v-html="formatTitle(item.title.value)"></h4>

		<div class="c-insights-tile__text">
			{{ item.abstract }}
		</div>

		<div class="c-insights-tile__footer">
			<time
				class="c-insights-tile__date"
				:datetime="item.articleDate ? new Date(item.articleDate).toISOString() : ''">
				{{
					item.articleDate
						? new Date(item.articleDate).toLocaleDateString("en-GB", {
								day: "numeric",
								month: "long",
								year: "numeric"
							})
						: ""
				}}&nbsp;
			</time>
			<span class="c-latest-insights__pod-reading-time">{{ item.readingTime }}</span>
		</div>
	</a>
</template>

<script>
	import { formatCaretToSpan } from "Util/text-formatter";

	export default {
		name: "insight-tile",
		props: ["item"],
		data() {
			return {};
		},

		methods: {
			formatTitle(text) {
				return formatCaretToSpan(text);
			}
		}
	};
</script>
